module.exports = __webpack_public_path__ + "img/someActionImg.a68600ca.png";